import { gql } from '@apollo/client';

export const NotifyAepOfContingentBuyer = gql`
  mutation NotifyAepOfContingentBuyer($addressToken: String!) {
    webBuyDirectListingOffer {
      notifyAepOfContingentBuyer(input: { listing: { addressToken: $addressToken } }) {
        status
      }
    }
  }
`;
